import { useState, useEffect, useRef, useCallback } from 'react';
import { IntersectionObserver } from 'client/utils/intersection-observer';

// Checks if the element is visible
export function useOnScreen(ref, options, enabled = true, updater = null) {
  const [isIntersecting, setIntersecting] = useState(false);
  const observer = useRef();

  const disconnect = useCallback(() => {
    if (observer.current) {
      observer.current.disconnect();
      if (updater === null) {
        observer.current = null;
      }
      setIntersecting(false);
    }
  }, [updater]);

  useEffect(() => {
    if (enabled && IntersectionObserver) {
      observer.current = new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting), options);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (observer.current && ref && ref.current) {
      observer.current.disconnect();
      observer.current.observe(ref.current);
    }
  }, [ref, updater]);

  useEffect(() => () => disconnect(), [disconnect]);

  return [isIntersecting, disconnect];
}
